import React from 'react';
import { SEO } from '../components/SEO';
export function ImpressumPage() {
  return <>
      <SEO title="Impressum - CRM Kraft | Justus Kraft" description="Impressum und rechtliche Angaben von CRM Kraft - Justus Kraft. Kontaktdaten, Umsatzsteuer-ID und Haftungsausschluss gemäß § 5 TMG." keywords="Impressum, CRM Kraft, Justus Kraft, rechtliche Angaben" ogType="website" data-id="element-397" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-398">
        <div className="max-w-4xl mx-auto" data-id="element-399">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-400">
            Impressum
          </h1>

          <div className="prose prose-invert prose-lg max-w-none" data-id="element-401">
            <section className="mb-8" data-id="element-402">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-403">
                Angaben gemäß § 5 TMG
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-404">
                Justus Kraft
                <br data-id="element-405" />
                CRM Kraft
                <br data-id="element-406" />
                Musterstraße 123
                <br data-id="element-407" />
                12345 Musterstadt
                <br data-id="element-408" />
                Deutschland
              </p>
            </section>

            <section className="mb-8" data-id="element-409">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-410">
                Kontakt
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-411">
                E-Mail: kontakt@crmkraft.de
                <br data-id="element-412" />
                Telefon: +49 (0) 123 456789
              </p>
            </section>

            <section className="mb-8" data-id="element-413">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-414">
                Umsatzsteuer-ID
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-415">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                Umsatzsteuergesetz:
                <br data-id="element-416" />
                DE123456789
              </p>
            </section>

            <section className="mb-8" data-id="element-417">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-418">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-419">
                Justus Kraft
                <br data-id="element-420" />
                Musterstraße 123
                <br data-id="element-421" />
                12345 Musterstadt
              </p>
            </section>

            <section className="mb-8" data-id="element-422">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-423">
                Haftungsausschluss
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-424">
                Haftung für Inhalte
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-425">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                hinweisen.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-426">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                Informationen nach den allgemeinen Gesetzen bleiben hiervon
                unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
                Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
                wir diese Inhalte umgehend entfernen.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-427">
                Haftung für Links
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-428">
                Unser Angebot enthält Links zu externen Websites Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-429">
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
                mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren
                zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
                inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
                konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
                Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
                Links umgehend entfernen.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-430">
                Urheberrecht
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-431">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten,
                nicht kommerziellen Gebrauch gestattet.
              </p>
            </section>
          </div>
        </div>
      </main>
    </>;
}